var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { State, Getter } from "vuex-class";
import { RoleService } from "~/services/management-service/role.service";
import { Emit, Prop } from "vue-property-decorator";
var ModifyRole = /** @class */ (function (_super) {
    __extends(ModifyRole, _super);
    function ModifyRole() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addModel = {
            roleName: "",
            roleStatus: "ENABLED",
            description: "",
            companyCode: "",
            id: ""
        };
        _this.rules = {
            roleName: [{ required: true, message: "请输入角色名称", trigger: "blur" }],
            roleStatus: [{ required: true, message: "请选择角状态", trigger: "change" }],
            description: [{
                    max: 500,
                    message: "描述不能超过500字符",
                    trigger: "blur"
                }]
        };
        return _this;
    }
    ModifyRole.prototype.refreshList = function () { };
    ModifyRole.prototype.close = function () { };
    ModifyRole.prototype.reset = function () {
        var from = this.$refs["form"];
        from.resetFields();
        if (this.roleData) {
            this.addModel.id = this.roleData.id;
            this.addModel.roleName = this.roleData.roleName;
            this.addModel.roleStatus = this.roleData.roleStatus;
            this.addModel.companyCode = this.roleData.companyCode;
            this.addModel.description = this.roleData.description;
        }
        else {
            this.addModel.id = '';
        }
    };
    /**
     * 提交验证并并与数据库交互
     */
    ModifyRole.prototype.commit = function () {
        var _this = this;
        var Form = this.$refs["form"];
        Form.validate(function (valid) {
            if (!valid)
                return;
            var result = _this.addModel.id ? _this.updateRole() : _this.addRole();
        });
    };
    /**
     * 新增角色
     */
    ModifyRole.prototype.addRole = function () {
        var _this = this;
        if (!this.isSupperAdmin) {
            this.addModel.companyCode = this.userData.companyCode;
        }
        this.RoleService.createRole(this.addModel).subscribe(function (data) {
            _this.$message.success('新增成功!');
            _this.refreshList();
            _this.close();
        });
        return true;
    };
    /**
     * 修改角色
     */
    ModifyRole.prototype.updateRole = function () {
        var _this = this;
        this.RoleService.updateRole(this.addModel).subscribe(function (data) {
            _this.$message.success('修改成功!');
            _this.refreshList();
            _this.close();
        });
        return true;
    };
    __decorate([
        Getter
    ], ModifyRole.prototype, "isSupperAdmin", void 0);
    __decorate([
        State
    ], ModifyRole.prototype, "companyList", void 0);
    __decorate([
        State
    ], ModifyRole.prototype, "userData", void 0);
    __decorate([
        Dependencies(RoleService)
    ], ModifyRole.prototype, "RoleService", void 0);
    __decorate([
        Prop({ type: Object })
    ], ModifyRole.prototype, "roleData", void 0);
    __decorate([
        Emit("refreshList")
    ], ModifyRole.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], ModifyRole.prototype, "close", null);
    ModifyRole = __decorate([
        Component({
            components: {}
        })
    ], ModifyRole);
    return ModifyRole;
}(Vue));
export default ModifyRole;
